module.exports = __webpack_public_path__ + "img/p4.05041de3.png";